import { ChevronDownIcon, ChevronUpIcon, XIcon } from "lucide-react";
import { useFileUploader } from "../../Hooks";
import { Loader, styled } from "@monolith-forensics/monolith-ui";

const StyledContainer = styled.div`
  &.header {
    width: 100%;
    height: 45px;
    padding: 10px;
    background-color: ${({ theme }) => theme.palette.background.default};
    color: ${({ theme }) => theme.palette.text.primary};
    display: flex;
    align-items: center;
    font-size: 12px;
  }
`;

export const Header = ({
  onMinClick = () => {},
  open,
  toggleVisibilty,
}: {
  onMinClick: () => void;
  open: boolean;
  toggleVisibilty: () => void;
}) => {
  const { uploading, files, uploadQueue } = useFileUploader();

  return (
    <StyledContainer className="header">
      <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
        <div>File Uploads</div>
        {!open && (
          <ChevronDownIcon
            onClick={onMinClick}
            style={{ marginLeft: 5, cursor: "pointer" }}
            size={16}
          />
        )}
        {open && (
          <ChevronUpIcon
            onClick={onMinClick}
            style={{ marginLeft: 5, cursor: "pointer" }}
            size={16}
          />
        )}
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          {files.length > 0 && (
            <div style={{ marginRight: 10 }}>
              {files.length - uploadQueue.length} of {files.length}
            </div>
          )}
          {uploading && <Loader style={{ width: 18, height: 18 }} />}
          {!uploading && (
            <XIcon
              onClick={toggleVisibilty}
              style={{ cursor: "pointer" }}
              size={16}
            />
          )}
        </div>
      </div>
    </StyledContainer>
  );
};
